import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UtilService} from '../../../services/util.service';

export const TypeNumeric = {
   Dolar: 'DL',
   Decimal: 'DC',
   Porcentaje: 'PR',
};

@Component({
   selector: 'input-numeric',
   templateUrl: './input-numeric.component.html',
   styles: []
})
export class InputNumericComponent {
   
   @Input() value: any;
   @Output() valueChange = new EventEmitter<string>();
   @Input() Type: string = '';
   
   constructor(
     private util: UtilService
   ) {
   }
   
   getCreateNumberMask() {
      switch (this.Type) {
         case TypeNumeric.Decimal:
            return this.util.getCreateDecimalMask();
         case TypeNumeric.Dolar:
            return this.util.getCreateDecimalDolarMask();
         case TypeNumeric.Porcentaje:
            return this.util.getCreatePorcentajeMask();
      }
   }
   
}
